class CollectionToolbar extends HTMLElement {
  #header = document.querySelector('header.shopify-section--header');
  #headerHeight = this.#getTopOffset();
  #abortController = new AbortController();

  connectedCallback() {
    const section = this.closest('section');
    this.nonStickyToolbar = section?.querySelector('[data-collection-non-sticky-toolbar]');

    if (!this.nonStickyToolbar) return;

    this.#initObserver();
    window.addEventListener('resize', () => this.#onResize(), {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#destroyObserver();
  }

  #getTopOffset() {
    return this.#header.getBoundingClientRect().height;
  }

  #onResize() {
    const newHeaderHeight = this.#getTopOffset();
    if (newHeaderHeight !== this.#headerHeight) {
      this.#headerHeight = newHeaderHeight;
      this.#initObserver();
    }
  }

  #initObserver() {
    this.#destroyObserver();

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.#hideStickyToolbar();
        } else {
          this.#showStickyToolbar();
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: `-${this.#headerHeight}px 0px 0px 0px`,
      }
    );

    this.observer.observe(this.nonStickyToolbar);
  }

  #destroyObserver() {
    this.observer?.disconnect();
    this.observer = null;
  }

  #showStickyToolbar() {
    this.classList.remove('opacity-0', 'pointer-events-none');
    this.setAttribute('aria-hidden', 'false');
    this.inert = false;
  }

  #hideStickyToolbar() {
    this.classList.add('opacity-0', 'pointer-events-none');
    this.setAttribute('aria-hidden', 'true');
    this.inert = true;
  }
}

customElements.define('sticky-collection-toolbar', CollectionToolbar);
